<div class="row justify-content-center" [hidden]="!this.isloaderVisible">
  <div class="col-lg-8 col-md-12">
    <div style="height: 70px" class="d-flex align-items-center justify-content-center">
      <div class="loading"></div>
    </div>
  </div>
</div>
<div [hidden]="this.isloaderVisible">
  <div #tableContainer class="table-responsive">
    <table class="table wre-table fixed-column mb-0">
      <thead>
        <tr>
          <th class="fixed-column action">&nbsp;</th>
          <th class="active text-center">Active</th>
          <th class="app-name">App Name</th>
          <th class="type">View Type</th>
          <th class="route-name">Route Name</th>
          <th class="order text-center">Order No.</th>
          <th class="anchor-id">Anchor Id</th>
          <th class="title">Title</th>
          <th class="content">Content</th>
        </tr>
      </thead>
      <tbody class="mb-0 pb-0">
        @for (item of TourStepsList; track item) {
          <tr>
            <td class="fixed-column action">
              <div ngbDropdown container="body">
                <button class="btn btn-secondary" ngbDropdownToggle>Action</button>
                <div ngbDropdownMenu>
                  @if (hasEditPermission) {
                    <button ngbDropdownItem (click)="onEdit(item.id, item.title)">Edit</button>
                  }
                  @if (hasDeletePermission) {
                    <button ngbDropdownItem (click)="onDelete(item.id, item.title)" class="delete">
                      Delete
                    </button>
                  }
                </div>
              </div>
            </td>
            <td class="active text-center">
              @if (item.isActive) {
                <i
                  class="fa fa-check wre-gateway-web-tour-steps-color-icon-fa-check"
                  aria-hidden="true"></i>
              } @else {
                <i
                  class="fa fa-times wre-gateway-web-tour-steps-color-icon-fa-times"
                  aria-hidden="true"></i>
              }
            </td>
            <td wreToolkitTitleWhenTruncated ngbTooltip container="body" class="app-name">
              {{ item.appName }}
            </td>
            <td class="type">
              @if (item.isMobile) {
                <span>Mobile View</span>
              } @else {
                <span>Normal View</span>
              }
            </td>
            <td wreToolkitTitleWhenTruncated ngbTooltip container="body" class="route-name">
              {{ item.routeName }}
            </td>
            <td class="order text-center">{{ item.stepId }}</td>
            <td wreToolkitTitleWhenTruncated ngbTooltip container="body" class="anchor-id">
              {{ item.anchorId }}
            </td>
            <td wreToolkitTitleWhenTruncated ngbTooltip container="body" class="title">
              {{ item.title }}
            </td>
            <td class="content">
              <a
                href="javascript:;"
                title="{{ item.content }}"
                (click)="onViewCentent(item.title, item.content)"
                >View Content</a
              >
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>
</div>
